<!--<div>-->
<!--    <h1>Thank you</h1>-->
<!--</div>-->
<!--<div>-->
<!--    <app-alert-success [message]="message"></app-alert-success>-->
<!--</div>-->
<div class="flex-column text-center" id="card-status-success-container">
    <div class="text-center mt-20" id="goodbye-icon-wrapper">
        <mat-icon id="goodbye-icon" class="icbc-alert-icon">check_circle_outline</mat-icon>
    </div>
    <div class="text-center">
        <h1> Thank you </h1>
    </div>
    <div id="thank-you-text-wrapper" class="text-center mt-20">
        <span id="thank-you-text" [innerHTML]="message"></span>
    </div>
    <div class="mt-50">
        <button mat-stroked-button class="icbc-button" (click)="returnToHomePage()">
            <!--            <a href="https://www.icbc.com/driver-licensing/getting-licensed/Pages/Your-driving-record.aspx">-->
            Return to Home
            <!--            </a>-->
        </button>
    </div>
</div>
